module.exports = __webpack_public_path__ + "static/media/ticketWhite.b0d211dd.svg";